import React, { useState, useEffect } from "react";
import Modal from "../../modal";
import { getAreas } from "../../../services/areas";
import { ErrorContext } from "../../../utils/context/error";

function FilterModal({ show, setShowM, AreaI, realizarConsulta }) 
{
  const [Areas, setAreas] = useState([]);
  const [AreaId, setAreaId] = useState(0);
  const [shows, setShow] = useState(show);
  const [habilita, setHabilita] = useState(false); 
  const [fechadesde, setFechaDesde] = useState("");
  const [fechahasta, setFechaHasta] = useState("");
  const { setShowToast, setOpciones } = ErrorContext();

  const handleArea = (e) => 
    {
       setAreaId(e.target.value);
    };
  
  //-----------------------------------------------------  
  const handleAceptar = (e) => 
    {
       realizarConsulta(AreaId, fechadesde, fechahasta);
       setShow(false);
       setShowM(false);
    };
  
  //-----------------------------------------------------  
  const fillSelectAreas = async () => 
    {
       const response = await getAreas();
       if (response) 
        {
           if (response.status === 200) 
            {
               setAreas(response.data.data);
            } 
           else 
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
        }
       setAreaId(AreaI);
    };
  
  //-----------------------------------------------------  
  useEffect(() => 
    {
       const fechaActual = new Date().toISOString().slice(0, 10);
       setFechaDesde(fechaActual);
       setFechaHasta(fechaActual);
       fillSelectAreas();
    }, []);

  //-----------------------------------------------------
  const handleCancel = async () => 
    {
      setShowM(false);
    };
  
  return (
    <>
      <Modal isOpen={show} onClose={()=>setShowM(false)} title={'Buscar'}>
        <div className="flex lg:w-[25rem]">
          <form noValidate className="flex flex-col w-full">
            <div className="flex flex-col w-full h-full ">
              <div className="w-full">
                <label>Area</label>
                <select id="area" name="area" value={AreaId || 0} onChange={(e) => setAreaId(e.target.value)} label="Area">
                  <option value={0} disabled>
                    Seleccionar una Area...
                  </option>
                    {Areas.map((item) => {
                      return (
                        <option key={item.AreaId} value={item.AreaId}>
                          {item.NombreArea}
                        </option>
                      );
                    })}
                </select>
              </div>
              <div className="flex w-full flex-row mt-4 gap-x-2">
               <div className="w-full">
                  <label>Fecha Desde</label>
                  <input id="date"  type="date" name="date" value={fechadesde} onChange={(e) => setFechaDesde(e.target.value)} autoComplete="off"/>
                </div>
                <div className="w-full">
                  <label>Fecha Hasta</label>
                  <input id="date"  type="date" name="date" value={fechahasta} onChange={(e) => setFechaHasta(e.target.value)} autoComplete="off"/>
                </div>
              </div>                        
            </div>
            <div className="flex w-full gap-4 mt-6 justify-end">
              <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
              <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
            </div> 
          </form>
        </div>
      </Modal>    
    </>
  );
}
export default FilterModal;
